import { Components } from 'formiojs';

const FieldComponent = Components.components.field;

export const template = {
  form: `<div class="data-qr">
            <div>
                <img src="{{ component.qrImageSrc }}" />
            </div>
           </div>`
};

export default class QrCode extends FieldComponent {
  static readonly type = 'qrcode';

  // @ts-ignore
  static schema() {
    return FieldComponent.schema({
      key: 'qrcode',
      type: QrCode.type
    });
  }

  // @ts-ignore
  render(): any {
    return super.render(this.renderTemplate(QrCode.type, {}));
  }
}
